const AgaveButton = ({ type, text, ...props }) => {
  return (
    <button className={`agave-button  ag-button-${type}`} {...props}>
      {text}
    </button>
  );
};

export default AgaveButton;
